import React from 'react';
import { Link } from 'react-router-dom';
import { featuredProjects } from '../../data/projects';

const FeaturedProjects: React.FC = () => {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real solutions that delivered measurable results for our clients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredProjects.map((project) => (
            <div key={project.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <div className="aspect-w-16 aspect-h-9 bg-gray-100">
                <img 
                  src={project.screenshots[0]} 
                  alt={project.title}
                  className="w-full h-48 object-cover object-top"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = '/projects/placeholder.jpg';
                  }}
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-gray-600 font-medium capitalize">
                    {project.category}
                  </span>
                  {project.metrics?.conversion && (
                    <span className="text-sm font-bold text-gray-800">
                      {project.metrics.conversion}
                    </span>
                  )}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {project.solution}
                </p>
                <Link
                  to={`/portfolio#${project.id}`}
                  className="text-gray-900 font-medium hover:text-gray-700"
                >
                  View Case Study →
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/portfolio"
            className="bg-gray-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
          >
            View All Projects
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProjects;
